import {
  onboardingRequestListSchema,
  onboardingRequestSchema,
  type OnboardingRequest,
  type OnboardingRequestStatus,
} from '@console/types'
import { z } from 'zod'
import { apiGet, apiPost } from '../api.js'
import { fetchCsrfToken } from '../auth/api.js'

export async function fetchOnboardingRequests(
  status: Extract<OnboardingRequestStatus, 'pending' | 'rejected'>,
): Promise<OnboardingRequest[]> {
  return apiGet(`/onboarding-requests?status=${status}`, onboardingRequestListSchema)
}

export async function acceptNamedOnboardingRequest(
  id: string,
  tenantName: string,
): Promise<OnboardingRequest> {
  const csrfToken = await fetchCsrfToken()
  return apiPost(
    `/onboarding-requests/${encodeURIComponent(id)}/accept-named`,
    { tenantName },
    csrfToken,
    onboardingRequestSchema,
  )
}

export async function requestMergeOtp(id: string, tenantId: string): Promise<void> {
  const csrfToken = await fetchCsrfToken()
  await apiPost(
    `/onboarding-requests/${encodeURIComponent(id)}/merge/request-otp`,
    { tenantId },
    csrfToken,
    z.object({ ok: z.literal(true) }),
  )
}

export async function confirmMergeOtp(
  id: string,
  tenantId: string,
  otp: string,
): Promise<OnboardingRequest> {
  const csrfToken = await fetchCsrfToken()
  return apiPost(
    `/onboarding-requests/${encodeURIComponent(id)}/merge/confirm-otp`,
    { tenantId, otp },
    csrfToken,
    onboardingRequestSchema,
  )
}

export async function rejectOnboardingRequest(id: string): Promise<OnboardingRequest> {
  const csrfToken = await fetchCsrfToken()
  return apiPost(
    `/onboarding-requests/${encodeURIComponent(id)}/reject`,
    undefined,
    csrfToken,
    onboardingRequestSchema,
  )
}
